import axios from 'axios';

axios.defaults.baseURL = window.baseURL + '/ajax';

axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-Request-Id'] = Date.now();

axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.defaults.withCredentials  = true; // если нужны куки
axios.defaults.timeout          = 5000; // таймаут запроса в миллисекундах
axios.defaults.maxContentLength = 20000; // максимальный размер ответа
axios.defaults.maxBodyLength    = 20000; // максимальный размер тела запроса

export default (app) => {
    app.axios = axios;
    app.$http = axios;

    app.config.globalProperties.axios = axios;
    app.config.globalProperties.$http = axios;
    app.provide('axios', axios);
}
